// export const  NAVIGATION_STEP= '@@NAVIGATION/STEP';
export const DEALER_DETAILS = '@@dealer/DETAILS';
export const ADDRESS_SEARCH = '@@address/DETAILS';
export const BASKET_ID = '@@BASKET_ID';

export const  APPOINTMENT_DETAILS = '@@APPOINTMENT/DETAILS';
export const FROM_LINK = '@@STEP/FROMLNK';
export const VEHICLE_INFOS = '@@VEHICLE/INFOS';
export const VEHICLE_EDIT = '@@VEHICLE/EDIT';
export const SELECTED_MILEAGE_STEP = '@@MILEAGE/SELECTED_STEP';
export const OPERATIONS = '@@QUOTING/OPERATIONS';
export const SELECTED_FORFAITS = '@@QUOTING/SELECTED_FORFAITS';
export const OPERATIONS_SELECTED = '@@QUOTING/OPERATIONS_SELECTED';
export const SELECTED_MANDATORY_ADDITIONAL_FORFAITS = '@@QUOTING/SELECTED_MANDATORY_ADDITIONAL_FORFAITS';
// export const COMMENT_SERVICES = '@@BOOKING/COMMENT_SERVICES';
export const PERSONAL_INFOS = '@@BOOKING/PERSONAL_INFOS';
export const SELECTED_PREMIUM_SERVICES = '@@BOOKING/SELECTED_PREMIUM_SERVICES';
export const PREMIUM_SERVICES = '@@BOOKING/PREMIUM_SERVICES';
// export const EDITMODE = '@@BOOKING/EDITMODE';
// export const DIALOG_CONFIRMATION_CHANGE_STEP = '@@DIALOGS/CONFIRMATION_CHANGE_STEP';
export const FILES = '@@BOOKING/FILES';
export const ATTACHMENTID = '@@BOOKING/ATTACHMENTID';
// export const DATELIMIT = '@@BOOKING/DATELIMIT';
// export const SELECTED_LAT = '@@BOOKING/SELECTED_LAT';
// export const SELECTED_LONG = '@@BOOKING/SELECTED_LONG';
// export const FILTER_DEALERS_BY = '@@BOOKING/FILTER_DEALERS_BY';
// export const FILTER_BY_CHOICE = '@@BOOKING/FILTER_BY_CHOICE';
// export const DEALERS_FILTRED = '@@BOOKING/DEALERS_FILTRED';
// export const IDRDVLEADS = '@@BOOKING/IDRDVLEADS';
